/* global Sys, WebKitCSSMatrix, Resources, Utils, Platform */
/**
 * A collection of utility functions.
 *
 * @class Sys.utils
 * @singleton
 */
Sys.ns("Sys.utils");

// extend Sys.utils in anonymous function in order to be able to get all
// methods in the Navigator bar to the right (does not work with Sys.extend(Sys.utils, {})
(function() {
    var utils = {

        /**
         * Converts a query string to an object with key value pairs.
         *
         * @example
         *     Sys.utils.queryStringToObject("?foo=bar&baz=w%20u%20t");       // => {foo: "bar", baz: "w u t"}
         *     Sys.utils.queryStringToObject("?foo=bar&baz=w%20u%20t", true); // => {foo: "bar", baz: "w u t"}
         *
         *     Sys.utils.queryStringToObject("?foo=bar&baz=w%20u%20t", false); // => {foo: "bar", baz: "w%20u%20t"}
         *
         * @param {string} qs The query string.
         * @param {boolean} [shouldUnescape=true] If values should be unescaped.
         * @returns {Object} The string parsed into key-value pairs.
         */
        queryStringToObject: function(qs, shouldUnescape) {
            // The return is a collection of key/value pairs
            var qsd = {},
                keyValuePair,
                value,
                decode = Sys.isDefined(shouldUnescape) ? shouldUnescape : true,
                pairs;

            // document.location.search is empty if no query string
            if (!qs) {
                return qsd;
            }

            // remove first questionmark and split by ampersand
            pairs = qs.replace("?", "").split(/&/);

            // Load the key/values of the return collection
            Sys.each(pairs, function(pair) {
                keyValuePair = pair.split("=");

                value = keyValuePair[1];
                if (decode) {
                    value = decodeURIComponent(value);
                }

                if (value === "false") {
                    value = false;
                }
                else if (value === "true") {
                    value = true;
                }

                qsd[keyValuePair[0]] = value;
            });

            // Return the key/value dictionary
            return qsd;
        },

        /**
         * Adds array parsing to queryStringToObject method that is needed for url processing.
         *
         * @example
         *     Sys.utils.parseUrlParams("?foo.0=bar1&foo.1=bar2&baz=w%20u%20t");       // => {foo: ["bar1", "bar2"], baz: "w u t"}
         * @param {string} qs Query string or url.
         * @returns {{}} The string parsed into key-value pairs.
         */
        parseUrlParams: function(qs) {
            var parsedObject = this.queryStringToObject(qs);

            // parses arrays
            Object.keys(parsedObject).forEach(function(generalKey) {
                var value = parsedObject[generalKey],
                    key,
                    index,
                    intIndex;

                // matches everything before . followed by numbers only
                key = generalKey.match(/.+(?=\.\d+(?!.+))/g);

                // matches only numbers at the end after .
                index = generalKey.match(/\.(\d+)(?!.+)/);
                index = index && index[1];

                if (key && index) {
                    intIndex = parseInt(index, 10);

                    if (!parsedObject[key]) {
                        parsedObject[key] = [];
                    }
                    parsedObject[key][intIndex] = value;
                    delete parsedObject[generalKey];
                }
            });

            return parsedObject;
        },

        /**
         * Appends a query string to a query string.
         *
         * @example
         *     Sys.utils.appendParameterToQuery("", "foo=bar")         // => "?foo=bar
         *     Sys.utils.appendParameterToQuery("?baz=wut", "foo=bar") // => "?baz=wut&foo=bar"
         *
         * @param {string} query A url with zero or more existing parameters.
         * @param {string} parameter A query string parameter on the form "&lt;key&gt;=&lt;value&gt;".
         * @returns {string} The query with the new parameter appended.
         */
        appendParameterToQuery: function(query, parameter) {
            var lastChar = query[query.length - 1];

            if (lastChar === "?" || lastChar === "&") {
                query += parameter;
            }
            else if (query.indexOf("?") === -1) {
                query += "?" + parameter;
            }
            else {
                query += "&" + parameter;
            }

            return query;
        },

        /**
         * Makes a http get request to the specified uri based on the configuration parameters.
         *
         * @param {Object} config The configuration object.
         * @param {string} config.url The resource URL.
         * @param {string} [config.responseType] Response type.
         * @param {Function} [config.onProgressCallback] A function on the form function(String event, String resourceName) that will be used as the requests onprogress listener.
         * @param {string} [config.name] Will be sent as the second parameter to any onProgressCallback function.
         * @param {boolean} [config.useCredentials] Use credentials or not.
         * @returns {Sys.Deferred} A Sys.Deferred object.
         */
        httpGet: function(config) {
            var request = new XMLHttpRequest(),
                deferred = new Sys.Deferred(),
                url = config.url;

            if (!url) {
                deferred.resolveWith([null]);
                return deferred;
            }

            request.onreadystatechange = function() {
                // If the request finished and response is ready (readyState 4)
                if (this.readyState === 4) {
                    request.onreadystatechange = function() {
                        /*
                         * Remove the change listener so that it does not get fired again (sometimes the ready state
                         * change event ios fired more than once).
                         */
                    };

                    if (Sys.utils.httpRequestIsOK(request)) {
                        // If we are getting an array buffer (audio file), don't parse it
                        if (config.responseType !== "arraybuffer" &&
                                (Sys.isDefined(Sys.utils.getErrorCode(request)) || Sys.isDefined(Sys.utils.getEvoErrorCode(request)))) {
                            deferred.rejectWith([request]);
                        }
                        else {
                            deferred.resolveWith([request]);
                        }
                    }
                    else {
                        deferred.rejectWith([request]);
                    }
                }
            };

            // If a onprogress callback is defined,
            // run it on the onprogress event and send back event object and the resource name
            if (Sys.isDefined(config.onProgressCallback)) {
                request.onprogress = function(event) {
                    config.onProgressCallback(event, config.name);
                };
            }

            request.open("GET", url);

            if (Sys.isDefined(config.responseType)) {
                request.responseType = config.responseType;
            }

            // NOTE: Important! this statement must be after the request.open method
            if (!Sys.isEmpty(config.useCredentials)) {
                request.withCredentials = config.useCredentials;
            }

            request.send();
            return deferred;
        },

        /**
         * Determines if a completed XMLHttpRequest is OK or not.
         *
         * @param {XMLHttpRequest} request The request to check.
         * @returns {boolean} Status.
         */
        httpRequestIsOK: function(request) {
            /*
             * status == 200 is the standard http OK status.
             * status == 0 indicates an application cache hit in some browsers (others use 200).
             * Cache hits should only be accepted if we actually get any data
             */
            return request.status === 200 || (request.status === 0 && request.responseText.length > 0);
        },

        /**
         * Retrieves any game server error code supplied in the request response text.
         *
         * @param {XMLHttpRequest} request The request to check.
         * @returns {number|undefined} The error code or undefined if no error code is found.
         */
        getErrorCode: function(request) {
            var errorCode = Sys.utils.toInt(Sys.utils.getResponseParameter("errorcode", request));

            return !isNaN(errorCode) ? errorCode : undefined;
        },

        /**
         * Retrieves any evo error code supplied in the request response text.
         *
         * @param {XMLHttpRequest} request The request to check.
         * @returns {number|undefined} The evo error code or undefined if no evo error code is found.
         */
        getEvoErrorCode: function(request) {
            var errorCode = Sys.utils.toInt(Sys.utils.getResponseParameter("evo-error-code", request));

            return !isNaN(errorCode) ? errorCode : undefined;
        },

        /**
         * Parses the given request's response for the error data.
         *
         * @deprecated 8.0.0. Use Sys.utils.getResponseParameter instead.
         * @param {XMLHttpRequest} request The request for which the response should be searched.
         * @returns {string|undefined} Error data.
         */
        getErrorData: function(request) {
            /* DEBUG_START */
            console.warn("The method Sys.utils.getErrorData(<request>) is deprecated, please use Sys.utils.getResponseParameter('errordata', <request>) instead.");

            /* DEBUG_END */
            return this.getResponseParameter("errordata", request);
        },

        /**
         * Parses the given request's response for the given parameter.
         *
         * @param {string} parameter The wanted response parameter.
         * @param {XMLHttpRequest} request The request for which the response should be searched.
         * @returns {string|undefined} The requested response parameter or undefined if it was not found.
         */
        getResponseParameter: function(parameter, request) {
            var searchQuery = new RegExp(parameter + "=([^&]+)"),
                searchResult = Sys.isDefined(request.responseText) ? request.responseText.match(searchQuery) : null;

            return searchResult !== null ? searchResult[1] : undefined;
        },

        /**
         * Returns given url parameter on oss if it exists, otherwise alternativeValue is retuned.
         *
         * @param {string} parameterName The wanted response parameter name.
         * @param {any} alternativeValue Alternative value for parameter returned if it is not taken from oss url params.
         * @returns {any} The requested response parameter or undefined if it was not found.
         */
        getOssParameter: function(parameterName, alternativeValue) {
            // On OSS return value from URL params if it exists
            if (Resources.readData("isOSSIntegration") && Sys.isDefined(Resources.readData("queryData")[parameterName])) {
                return Resources.readData("queryData")[parameterName];
            }

            return alternativeValue;
        },

        /**
         * Takes value from ag if agBalanceEnabled, otherwise uses response argument.
         *
         * @param {any} response Server response.
         * @returns {any} Returns true if free rounds are active.
         */
        isFreeRoundsActive: function(response) {
            return Resources.readData("agBalanceEnabled") ? Resources.readData("isAgFreeRoundsActive") : parseInt(response.freeRoundsLeft, 10) > 0;
        },

        /**
         * Creates a script tag and appends it to &lt;head&gt; element. Executes callback when onload event is fired.
         * NOTE that this function implements "fail" with a setTimeout since there is no "actual" way of knowing when a JavaScript file load fails.
         *
         * @deprecated 7.5.2. Should not inject JavaScript directly.
         * @param {Object} config Config object.
         * @param {string} config.url The URL of the script.
         * @returns {Sys.Deferred} A Deferred object.
         */
        loadJS: function(config) {
            var deferred = new Sys.Deferred(),
                element = document.createElement("script");

            element.addEventListener("load", function() {
                deferred.resolve();
            });
            element.type = "text/javascript";
            element.src = config.url;

            // handle fails by setTimeout, assuming that the file load failed after a while
            // not very nice but at the time of writing the only way to know if the script has not loaded
            setTimeout(function() {
                if (!deferred.isResolved()) {
                    console.error("Failed to load: " + element.src);
                    deferred.reject();
                }
            }, 5000);

            document.getElementsByTagName("head")[0].appendChild(element);
            return deferred;
        },

        /**
         * Checks weather the string is true or false.
         *
         * @param {string} boolStr The string containing a boolean value.
         * @returns {boolean} True if string is "true", false otherwise.
         */
        strIsTrue: function(boolStr) {
            if (Sys.isEmpty(boolStr)) {
                return false;
            }

            return boolStr.toString().toLowerCase() === "true";
        },

        /**
         * Helper function that generates almost unique IDs.
         *
         * @returns {string} Pseudo-GUID, as described here: http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript.
         */
        pseudoGUID: function() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);

                return v.toString(16);
            });
        },

        /**
         * Replaces all {x} in string with object[x].
         *
         * @example
         *     Sys.utils.getNodesByFormat("{1} {2}",["Hello", "World"]) // => [textNode("Hello"), textNode(" "), textNode("World")]
         *
         * @param {string} text The text string that may contain {}.
         * @param {Object[]} values The array containing the objects to be used for building up the resulting array.
         * @returns {HTMLElement[]} The resulting array with DOM nodes.
         */
        getNodesByFormat: function(text, values) {
            var me = this,
                res = [],

                // Keep track on offset if there are multiple "{ }" matches
                prevOffset = 0,
                f;

            // Regexp text to find all "{}" matches
            text.replace(/\{([^\{\}]*)\}/g, function(match, group_match, offset, t) {
                // Create a text node for the first (string) part
                res.push(document.createTextNode(t.slice(prevOffset, offset)));

                // Set new offset
                prevOffset = offset + match.length;

                f = function() {
                    var obj = values[Sys.utils.toInt(group_match)];

                    // Evaluate type of object that was sent in the values array
                    // and add to resulting html node array

                    // If it is a string then create a text node for the it
                    if (typeof obj === "string" || Sys.isNumber(obj)) {
                        res.push(document.createTextNode(obj.toString()));

                        return obj;
                    }
                    // If it is a object then add the DOM element
                    // (which is a html element)
                    else if (Sys.isObj(obj)) {
                        res.push(obj.getEl());
                    }
                    return "";
                };

                f.apply(me, arguments);
            });

            // Add last text (if there is any)
            if (prevOffset < text.length) {
                res.push(document.createTextNode(text.slice(prevOffset, text.length)));
            }

            return res;
        },

        /**
         * Sorts an array of object by numeric object field defined by parameter.
         *
         * @param {Object[]} arr The array of objects which is to be sorted.
         * @param {string} prop The name of the field that the array is to be sorted upon. Must exist in every object in the array.
         * @param {boolean} [desc=false] Flag to set descending sort.
         * @returns {Object[]} The sorted array of objects.
         */
        objSort: function(arr, prop, desc) {
            // create sorter function
            var sortFn = function(a, b) {
                // if descending, reverse sort
                return desc ? b[prop] - a[prop] : a[prop] - b[prop];
            };

            // sort array
            arr.sort(sortFn);

            return arr;
        },

        /**
         * A wrapper for the standard Javascript parseInt to omit the specification of the radix value.
         *
         * @example
         *     Sys.utils.toInt("015");   // => 15
         *     Sys.utils.toInt("15.99"); // => 15
         *     Sys.utils.toInt("15*3");  // => 15
         *     Sys.utils.toInt("15px");  // => 15
         *     Sys.utils.toInt(15.99);   // => 15
         *
         * @param {string} value The string to be parsed.
         * @returns {number} The parsed integer number.
         */
        toInt: function(value) {
            return parseInt(value, 10);
        },

        /**
         * A wrapper for the standard Javascript parseFloat.
         *
         * @example
         *     Sys.utils.toFloat("3.14");                          // => 3.14
         *     Sys.utils.toFloat("314e-2");                        // => 3.14
         *     Sys.utils.toFloat("0.0314E+2");                     // => 3.14
         *     Sys.utils.toFloat("3.14more non-digit characters"); // => 3.14
         *
         * @param {string} value The string containing the value to be parsed.
         * @returns {number} The parsed float number.
         */
        toFloat: function(value) {
            return parseFloat(value);
        },

        /**
         * Rounds down to nearest even integer.
         *
         * @example
         *     Sys.utils.floorToEven(2); // => 2
         *     Sys.utils.floorToEven(3); // => 2
         *     Sys.utils.floorToEven(4); // => 4
         *
         * @param {number} value The number to floor.
         * @returns {number} The floored number.
         */
        floorToEven: function(value) {
            var rest = value % 2;

            return value - rest;
        },

        /**
         * Rounds up to nearest even integer.
         *
         * @example
         *     Sys.utils.ceilToEven(2); // => 4
         *     Sys.utils.ceilToEven(3); // => 4
         *     Sys.utils.ceilToEven(4); // => 6
         *
         * @param {number} value The number to ceil.
         * @returns {number} The ceiled number.
         */
        ceilToEven: function(value) {
            var rest = value % 2;

            return value + (2 - rest);
        },

        /**
         * Returns a string of the number with **digits** digits.
         *
         * @example
         *     Sys.utils.numberToFixedDigits(0.1, 3); // => 0.10
         *     Sys.utils.numberToFixedDigits(1, 3);   // => 1.00
         *
         * @param {number} number The number that shall be returned in fixed number of digits.
         * @param {number} digits Number of digits that the return value shall have. Has to be between 1 and 21.
         * @returns {string} Fixed digits.
         */
        numberToFixedDigits: function(number, digits) {
            if (digits <= 0) {
                throw Error("digits can't be 0 or less");
            }
            if (Math.abs(number) < 1) {
                return number.toFixed(digits - 1);
            }

            if (number.toString().length >= digits) {
                return number.toString();
            }

            return number.toPrecision(digits);
        },

        /**
         * @param {string} url The url string to test.
         * @returns {boolean} True/False depending on if the specified string is an url or not.
         */
        isUrl: function(url) {
            var regexp = new RegExp("(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?");

            return regexp.test(url);
        },

        /**
         * Returns the offset of a DOM element relative to the entire document.
         * Also used by Sys.Element.getOffset.
         *
         * @param {HTMLElement} el A reference to a DOM element.
         * @returns {{left: number, top: number, x: number, y: number}} An object with properties "left" and "top" to indicate the offset in pixels.
         */
        getElOffset: function(el) {
            var currLeft = 0,
                currTop = 0;

            // offsetParent returns a reference to the object which is the closest (nearest in the containment
            // hierarchy) positioned containing element. If the element is non-positioned, the nearest table
            // cell or root element (html in standards compliant mode; body in quirks rendering mode) is the
            // offsetParent. offsetParent returns null when the element has style.display set to "none".
            // The offsetParent is useful because offsetTop and offsetLeft are relative to its padding edge.
            if (el.offsetParent) {
                do {
                    currLeft += el.offsetLeft;
                    currTop += el.offsetTop;
                } while ((el = el.offsetParent));
            }

            return {
                left: currLeft,
                top: currTop,
                x: currLeft,
                y: currTop
            };
        },

        /**
         * Returns the accumulated offset of -webkit-transformations.
         *
         * @param {HTMLElement} el A reference to a DOM element.
         * @returns {{left: number, top: number, x: number, y: number}} An object with properties "left" and "top" to indicate the offset in pixels.
         */
        getTransformationOffset: function(el) {
            var x = 0,
                y = 0,
                transform;

            if (el.parentElement) {
                do {
                    transform = new WebKitCSSMatrix(window.getComputedStyle(el).webkitTransform);
                    x += transform.e;
                    y += transform.f;
                } while ((el = el.parentElement));
            }
            return {
                left: x,
                top: y,
                x: x,
                y: y
            };
        },

        /**
         * Returns the coordinates where the user is pointing at.
         *
         * @private
         * @param {Object} event The javascript event object.
         * @returns {{x: number, y: number}} The coordinates of the event.
         */
        getPointCoordinates: function(event) {
            var coords = {
                    x: 0,
                    y: 0
                },
                type = event.type;

            // mouse events will have their coordinates directly in the event object
            // touch events have the coordinates in a "touches" array
            // I use changedTouches array as the touches array is empty for touchEnd
            if (/touch/.test(type)) {
                coords.x = event.changedTouches[0].pageX;
                coords.y = event.changedTouches[0].pageY;
            }
            else if (/mouse/.test(type)) {
                coords.x = event.x;
                coords.y = event.y;
            }

            return coords;
        },

        /**
         * Points to browser to a new location through window.location.
         * This is useful because we can override it during testing.
         *
         * @deprecated 7.5.2. Use Sys.utils.setWindowLocation().
         * @param {string} url The URL to point the browser to.
         * @returns {void}
         */
        goTo: function(url) {
            window.location = this.sanitizeURL(url);
        },

        /**
         * Creates a query string from an object.
         *
         * @param {Object} obj Object.
         * @returns {string} String.
         */
        objectToQueryString: function(obj) {
            var string = "",
                prop;

            for (prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    string += "&" + prop + "=" + obj[prop];
                }
            }
            return string;
        },

        /**
         * Reloads the window.
         * This is useful because we can override it for iFrame specific code.
         *
         * @returns {void}
         */
        reload: function() {
            window.location.reload();
        },

        /**
         * Checks if a specified object exist in an array.
         *
         * @param {Object} obj The object we want to check.
         * @param {Array} list The array to test if it contains the object.
         * @returns {{found: boolean, index: number}} The result, if it found it and at what index.
         */
        containsObject: function(obj, list) {
            var i;

            if (Sys.isObj(obj) && Sys.isArray(list)) {
                for (i = 0; i < list.length; i++) {
                    if (list[i] === obj) {
                        return { found: true, index: i };
                    }
                }
            }
            else {
                console.warn("Input to Sys.utils.containsObject is not an object and an array");
            }

            return { found: false, index: NaN };
        },

        /**
         * Get the properties owned by the object it fetches the properties from the Obj.keys in case od ES5 otherwise collect the properties through iterations.
         *
         * @param {Object} obj Object.
         * @returns {string[]} Array of strings representing the keys of the object.
         */
        getKeys: function(obj) {
            var keys = [],
                i,

                // this is the predefined method in ES5 refer https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
                getObjectProperties = obj.keys;

            // do a polyfill if ES5 Object.keys does not exist
            if (typeof getObjectProperties !== "function") {
                for (i in obj) {
                    if (obj.hasOwnProperty(i)) {
                        keys.push(i);
                    }
                }
            }
            else {
                keys = getObjectProperties(obj);
            }
            return keys;
        },

        /**
         * Utility function to initialize a two dimensional matrix with the given value on all indices.
         *
         * @param {number} outerDimension Length of the outer array.
         * @param {number} innerDimension Length of all the inner arrays.
         * @param {*} [initValue=undefined] The value every index should be initialized to.
         * @returns {Array} An initValue[outerDimension][innerDimension] matrix.
         */
        init2dMatrix: function(outerDimension, innerDimension, initValue) {
            var i,
                matrix = [];

            for (i = -1; ++i < outerDimension;) {
                matrix.push(Sys.utils.initArray(innerDimension, initValue));
            }

            return matrix;
        },

        /**
         * Utility function to initialize an array with the given value on all indices.
         *
         * @param {number} length Length of the array.
         * @param {*} [initValue=undefined] The value every index should be initialized to.
         * @returns {Array} Array.
         */
        initArray: function(length, initValue) {
            var i,
                array = [];

            /* DEBUG_START */
            if (Sys.isObj(initValue) || Sys.isArray(initValue)) {
                console.warn("WARNING: Array initialization with reference as initValue: ", initValue);
            }

            /* DEBUG_END */

            for (i = -1; ++i < length;) {
                array.push(initValue);
            }

            return array;
        },

        /**
         * Gets the scaling prefix available in the current browser.
         *
         * @param {string} prop The property to test.
         * @returns {string|undefined} Prefix.
         */
        getPrefixedCSSProperty: function(prop) {
            var prefixed = this.tryPrefixPropery(prop, document.body.style);

            return prefixed;
        },

        /**
         * Check if browser need to prefix property and return it.
         *
         * @deprecated 7.5.2. Prefixed styling should be handled by adding classes and using CSS.
         * @param {string} property The property to test.
         * @param {Object} style Element style object.
         * @returns {string|undefined} Key.
         */
        tryPrefixPropery: function(property, style) {
            var prefixedProperty,
                prefixes = ["webkit", "moz", "ms", "o"],
                suffix,
                i;

            if (!Sys.isDefined(property)) {
                return undefined;
            }

            if (property in style) {
                return property;
            }

            suffix = property.charAt(0).toUpperCase() + property.substr(1);

            for (i = 0; i < prefixes.length; i++) {
                prefixedProperty = prefixes[i] + suffix;
                if (prefixedProperty in style) {
                    return prefixedProperty;
                }
            }

            return undefined;
        },

        /**
         * Tries a DOM element for variations of the feature and returns the working one or undefined if no match was found.
         *
         * @deprecated 7.5.2. Use Sys.utils.getPrefixedCSSProperty instead.
         * @param {string} feature The feature you want to pollyFill (to use with el.style.feature = xxx).
         * @returns {string|undefined} Polyfill.
         */
        pollyFill: function(feature) {
            return this.getPrefixedCSSProperty(feature);
        },

        /**
         * Parses a query string into a JavaScript object.
         *
         * @private
         * @deprecated 7.5.2. Use Sys.utils.parseQueryString().
         * @param {string} queryString A query string (for instance the server request response text).
         * @returns {Object} The response parsed into an object.
         */
        parseQueryStringToNestedObject: function(queryString) {
            return this.parseQueryString(queryString, true);
        },

        /**
         * Parses query string to json object.
         *
         * NOTE: This only works for the NetEnt custom formatted server query string. If you wish to parse a standard
         * query string then Sys.utils.queryStringToObject might be a better option.
         *
         * @example
         * Sys.utils.parseQueryString("pluginURL=http%3A%2F%2Fservername%2Fgame-inclusion%2Fbranches%2Ftest%2Fexample%2Fplugin%2FtestPlugin.html")
         *
         * -> Object {pluginURL: "http://10.99.12.80/game-inclusion/branches/test/example/plugin/testPlugin.html"}
         *
         * Sys.utils.parseQueryString("queryStringObject=a%3Atest%20value", true)
         *
         * -> Object {
         *     queryStringObject: {
         *         a: "test value"
         *     }
         * }
         *
         * @param {string} queryString Query string.
         * @param {boolean} [nested=false] If the parsing should be a nested.
         * @returns {Object} Query object.
         */
        parseQueryString: function(queryString, nested) {
            var queryObject = {},
                stringParts = queryString.split("&"),
                part,
                keyValuePair,
                path,
                step,
                object,
                key,
                value;

            for (part = 0; part < stringParts.length; part++) {
                keyValuePair = stringParts[part].split("=");
                path = keyValuePair[0].split(".");
                object = queryObject;

                for (step = 0; step < path.length - 1; step++) {
                    if (!object[path[step]]) {
                        object[path[step]] = {};
                    }
                    object = object[path[step]];
                }

                key = path[path.length - 1];
                value = nested === true ? this.parseValue(decodeURIComponent(keyValuePair[1])) : decodeURIComponent(keyValuePair[1]);
                if (key !== "") {
                    object[key] = value;
                }
            }

            return queryObject;
        },

        /**
         * Recursively parses a value string into a suitable JavaScript type.
         *
         * @private
         * @param {string} rawValue The value as a string.
         * @returns {boolean|number|Array|Object|string} The raw value parsed into a suitable JavaScript type or the raw data itself if no improvement could be made.
         */
        parseValue: function(rawValue) {
            var value,
                i,
                xmlDoc,
                keyValuePair = {};

            // Parse boolean values
            if (rawValue.toLowerCase() === "true") {
                return true;
            }
            if (rawValue.toLowerCase() === "false") {
                return false;
            }

            // Parse null
            if (rawValue.toLowerCase() === "null") {
                return null;
            }

            // Parse undefined
            if (rawValue.toLowerCase() === "undefined") {
                return undefined;
            }

            // Parse numbers
            if (!isNaN(Number(rawValue))) {
                // Javascript can't handle numbers bigger than 2^53 (16 digits) so casting numbers larger than that will
                // cause all digits after the 16th to be replaced with zeroes.
                // One example of this is the rgi token used for Open Bet (example: "231420150611172418471").
                if (rawValue.length > 16) {
                    return rawValue;
                }

                return Number(rawValue);
            }

            // Parse arrays
            if (rawValue.split(",").length > 1) {
                value = rawValue.split(",");
                for (i = 0; i < value.length; i++) {
                    value[i] = this.parseValue(value[i]);
                }
                return value;
            }

            // try to parse xml
            xmlDoc = new DOMParser().parseFromString(
                rawValue.replace(/\+/g, " "),
                "application/xml"
            );

            if (xmlDoc.documentElement && xmlDoc.getElementsByTagName("parsererror").length === 0) {
                return rawValue;
            }

            // Parse key/value pairs. Note that this must be done after parsing arrays or arrays of key/value pairs would not be parsed properly
            if (rawValue.split(":").length > 1) {
                value = rawValue.split(":");
                keyValuePair[value[0]] = this.parseValue(value[1]);
                return keyValuePair;
            }

            // In case we cannot parse the value we return it as it is as it is probably just some string
            return rawValue;
        },

        /**
         * Parses the reel info into an object containing symbol, overlay and hold (used in re-spins) information.
         *
         * @example
         *     reelInfo[i]
         *     {
         *         hold : false,
         *         symbols : ["SYM2","SYM3","SYM2"],
         *         overlaySymbols : [undefined,"SYM33",undefined]
         *     }
         *
         * @param {Object} parsedServerResponse Server response as parsed by Core.ResponseParserController.parseServerResponse.
         * @param {string} [reelSetID] The ID of the reel set that should be parsed. Default reel set is i0.
         * @returns {Object[]} Reel info.
         */
        parseReelInfo: function(parsedServerResponse, reelSetID) {
            var rawReelInfo,
                reelInfo = [],
                reel,
                info;

            // First we try to find a reel set with the given id
            if (Sys.isDefined(reelSetID)) {
                Sys.iterate(parsedServerResponse.rs, function(reelSetIndex, reelSetInformation) {
                    if (Sys.isObj(reelSetInformation) && reelSetInformation.id === reelSetID) {
                        rawReelInfo = reelSetInformation.r;
                    }
                });
            }

            // Then we fallback if needed
            if (!Sys.isDefined(rawReelInfo)) {
                // rs.i0 should always be present
                rawReelInfo = parsedServerResponse.rs.i0.r;
            }

            for (reel = 0; Sys.isDefined(rawReelInfo["i" + reel]); reel++) {
                info = {
                    hold: rawReelInfo["i" + reel].hold,
                    symbols: rawReelInfo["i" + reel].syms,
                    overlaySymbols: []
                };

                if (rawReelInfo["i" + reel].overlay) {
                    info.overlaySymbols = this.getOverlaySymbols(rawReelInfo["i" + reel].overlay);
                }

                reelInfo.push(info);
            }

            return reelInfo;
        },

        /**
         * Get the overlay symbol information from the given overlay info.
         *
         * @private
         * @param {Object} overlay Overlay information for a reel.
         * @param {Object} overlay.iY Overlay information for overlay Y on the reel.
         * @param {string} overlay.iY.row The row where overlay Y appears on the reel.
         * @param {string} overlay.iY.with The symbol overlay Y overlays with on the reel.
         * @returns {string[]} Overlay info.
         */
        getOverlaySymbols: function(overlay) {
            var overlayInfo = [],
                i;

            // Example:
            // reelInfo.overlay.i0.row : 1
            // reelInfo.overlay.i0.with : "SYM10"
            for (i = 0; overlay["i" + i]; i++) {
                overlayInfo[overlay["i" + i].row] = overlay["i" + i].with;
            }

            return overlayInfo;
        },

        /**
         * Get the class reference based on the string.
         *
         * @param {string} className The class name (including scope).
         * @returns {*} The reference to the class or undefined if the class does not exist.
         */
        getClassFromString: function(className) {
            var parts,
                classReference = window,
                i,
                numParts;

            if (typeof className === "string") {
                parts = className.split(".");
                numParts = parts.length;

                for (i = 0; i < numParts; i++) {
                    classReference = classReference[parts[i]];
                    if (!Sys.isDefined(classReference)) {
                        return undefined;
                    }
                }

                return classReference;
            }

            return undefined;
        },

        /**
         * Open the url in a new tab if possible, else open in the current window.
         *
         * @param {string} url The URL to open.
         * @param {string} name An id for the new tab, will prevent opening of several tabs if one is already open.
         * @returns {void}
         */
        openURL: function(url, name) {
            var sanitizedUrl = this.sanitizeURL(url);

            // It is not possible to open new tabs in Internet Explorer on some Windows Phones.
            // It throws an exception on window.open, therefore we use window.location instead.
            try {
                this.openNewBrowserTab(sanitizedUrl, name);
            }
            catch (e) {
                this.setWindowLocation(sanitizedUrl);
            }
        },

        /**
         * Sanitizes url by first checking for valid http protocol. Then replaces any greater-than or lesser-than characters to prevent XSS.
         *
         * @example
         * http://www.example.com => valid
         * https://www.example.com => valid
         * //www.example.com => valid
         *
         * ftp://www.example.com => invalid
         *
         * http://www.example.com/<script>alert('hello');</script> => http://www.example.com/&lt;script&gt;alert('hello');&lt;script&gt;
         *
         * @param {string} url Url to sanitize.
         * @returns {?string} Sanitized url or null.
         */
        sanitizeURL: function(url) {
            var checkForProtocolRegexp = /^(https?:)?\/\//,
                arrowRegexp = /<|>/g,
                arrowMap = {
                    "<": "&lt;",
                    ">": "&gt;"
                };

            if (!checkForProtocolRegexp.test(url)) {
                return null;
            }

            return url
                .replace(arrowRegexp, function(matched) {
                    return arrowMap[matched];
                });
        },

        /**
         * Checks if criteria is met consistently over frames so callback can correctly be fired.
         *
         * @deprecated 7.5.2. Not in use.
         * @param {Function} criteria Exit criteria.
         * @param {Function} callback Exit callback.
         * @returns {void}
         */
        onTransitionCheck: function(criteria, callback) {
            Sys.utils.checkTransition(criteria, callback, false);
        },

        /**
         * Checks transition.
         *
         * @deprecated 7.5.2. Not in use.
         * @param {Function} criteria Exit criteria.
         * @param {Function} callback Exit callback.
         * @param {boolean} allowTransition Weather or not to allow transition.
         * @returns {void}
         */
        checkTransition: function(criteria, callback, allowTransition) {
            if (criteria()) {
                if (allowTransition) {
                    callback();
                }
                else {
                    window.requestAnimationFrame(function() {
                        Sys.utils.checkTransition(criteria, callback, true);
                    });
                }
            }
            else {
                window.requestAnimationFrame(function() {
                    Sys.utils.checkTransition(criteria, callback, false);
                });
            }
        },

        /**
         * Sends the user to the lobby with the given reason using window.location.
         *
         * @param {number} [reason] The reason (an integer) given for going to lobby.
         * @returns {void}
         */
        goToLobby: function(reason) {
            var lobbyUrl = Resources.readData("lobbyUrl");

            if (lobbyUrl) {
                if (Utils.Platform.inIframe() && lobbyUrl === "#") {
                    window.parent.postMessage(["event", "goToLobby", reason], "*");
                }
                else {
                    this.setWindowLocation(this.processLobbyUrl(lobbyUrl, reason));
                }
            }
            else {
                console.warn("Environment#goToLobby - lobbyURL can not be resolved.");
            }
        },

        /**
         * Checks if home button is available or not based on platform and lobbyURL.
         *
         * @returns {boolean} Home button is available or not.
         */
        isHomeAvailable: function() {
            var lobbyUrl = Resources.readData("lobbyUrl"),
                lobbyUrlExists = lobbyUrl !== undefined && lobbyUrl !== "undefined" && lobbyUrl !== "" && lobbyUrl !== null;

            return lobbyUrlExists && !Platform.isDesktopDevice;
        },

        /**
         * Process lobby url in the way it moves query string fragment (i.e. Hash value and everything behind it), to the end of query string.
         * If some query parameters have been passed on launch - it still move just fragment to the end, forming proper query string.
         * If no fragment provided - just add required query parameters to lobby url.
         * NOTE: if operator malformed lobby url, i.e. Put REQUIRED query parameter after hash value - it have to be handled on operator side, as it violates "standard" way of handling URL's.
         *
         * @param {string} rawLobbyUrl Represents raw lobby url passed by operator via game inclusion.
         * @param {number} reason Represents reason why player have left the game.
         *
         * @returns {string} LobbyUrl Properly formed lobby url query string, i.e. Hash value (fragment) moved to the end of query string.
         * */
        processLobbyUrl: function(rawLobbyUrl, reason) {
            var queryData = Resources.readData("queryData"),
                sessionID = Resources.readData("sessionID"),
                hashValueRE = /#.*/,
                hashValue = "",
                lobbyUrl;

            // extract and replace URI fragment
            if (hashValueRE.test(rawLobbyUrl)) {
                hashValue = hashValueRE.exec(rawLobbyUrl)[0];
                lobbyUrl = rawLobbyUrl.replace(hashValueRE, "");
            }
            else {
                lobbyUrl = rawLobbyUrl;
            }

            if (typeof reason !== "undefined") {
                lobbyUrl = Sys.utils.appendParameterToQuery(lobbyUrl, "reason=" + reason);
            }

            if (queryData) {
                if (queryData.gameId) {
                    lobbyUrl = Sys.utils.appendParameterToQuery(lobbyUrl, "gameId=" + queryData.gameId);
                }

                if (sessionID) {
                    lobbyUrl = Sys.utils.appendParameterToQuery(lobbyUrl, "sessId=" + sessionID);
                }
            }
            // add URI fragment back to the query string
            lobbyUrl += hashValue;

            return lobbyUrl;
        },

        /**
         * Calls the goToLobby function with the cashier specific reason (5).
         *
         * @returns {void}
         */
        goToCashier: function() {
            this.goToLobby(5);
        },

        /**
         * Changes the window location.
         *
         * @param {string} url The Url to the new location.
         * @returns {void}
         */
        setWindowLocation: function(url) {
            window.location.href = this.sanitizeURL(url);
        },

        /**
         * Points to browser to a new location through window.location.
         *
         * @param {string} url The URL to point the browser to.
         * @param {string} name An id for the new tab, will prevent opening of several tabs if one is already open.
         * @returns {void}
         */
        openNewBrowserTab: function(url, name) {
            window.open(url, name).focus();
        },

        /**
         * Creates an element with class names.
         *
         * @param {string} tagName Tag name of the element. Must be lowercase.
         * @param {Array} [classNames] Class names for the element.
         * @returns {HTMLElement} The element representing the background.
         */
        createElement: function(tagName, classNames) {
            var el = document.createElement(tagName);

            (classNames || []).forEach(function(className) {
                el.classList.add(className);
            });

            return el;
        },

        /**
         * Create queryString of the parameters which has prefix value.
         *
         * @param {Object} queryObj Object.
         * @param {string} prefix - Parameter contains prefix string.
         * @returns {string} String.
         */
        objToQueryStrHavingPrefixValue: function(queryObj, prefix) {
            var string = "",
                prop;

            for (prop in queryObj) {
                if (prop.indexOf(prefix) === 0) {
                    string += "&" + prop + "=" + encodeURIComponent(queryObj[prop]);
                }
            }
            return string;
        },

        /**
         * Debounce func so it is called once per given time.
         *
         * @param {Function} func Function that should be debounced.
         * @param {number} time Time in ms after which updates are flushed.
         * @returns {Function} Function that invokes debounce.
         */
        debounce: function(func, time) {
            var id;

            return function() {
                clearTimeout(id);
                id = setTimeout(func, time);
            };
        },

        /**
         * Remove trailing slash in string.
         *
         * @param {string} text Text to remove trailing slash in.
         * @returns {string} Given text without trailing slash.
         */
        removeTrailingSlash: function(text) {
            return text.replace(/\/$/, "");
        }
    };

    Sys.utils = Sys.apply(Sys.utils, utils);
}());
